import axios from "axios";

// Turns an axios failure into something worth showing a user.
//
// The API answers in one of two shapes — { errors: { field: [msg, ...] } } for
// validation failures and the role gates, or { message: "..." } — while a
// transport failure has neither. Callers used to swallow all of this and render
// an empty list, which made "no permission" and "no data" look identical.
//
// Returns "" for a cancelled request so callers can bind straight to v-if
// without flashing a banner when they abort their own in-flight call.
export function apiErrorMessage(err, fallback = "Something went wrong.") {
  if (axios.isCancel && axios.isCancel(err)) return "";

  const response = err && err.response;
  const data = response && response.data;

  if (data && data.errors && typeof data.errors === "object") {
    const messages = Object.values(data.errors).flat().filter(Boolean);
    if (messages.length) return messages.join(" ");
  }
  if (data && data.message) return String(data.message);
  if (response && response.status === 403) {
    return "You don't have permission to view this.";
  }
  // No response at all — DNS, CORS, offline, server down.
  if (!response && err && err.message) {
    return `Cannot reach the server: ${err.message}`;
  }
  return fallback;
}
